import AA from '../assets/parties_logos/logo_adelante_andalucia.svg';
import CS from '../assets/parties_logos/logo_ciudadanos.svg';
import PP from '../assets/parties_logos/logo_pp.svg';
import PSOE from '../assets/parties_logos/logo_PSOE-A.svg';
import VOX from '../assets/parties_logos/logo_vox.svg';
import Sentisis from '../assets/sentisis_logo.svg';
export const logos = {
  'PSOE-A': PSOE,
  PP,
  'ADELANTE ANDALUCÍA': AA,
  Cs: CS,
  VOX
};
export const SentisisLogo = Sentisis;